<template>
  <Line
      :options="chartOptions"
      :data="chartData"
  />
</template>
<script>
import {Line} from 'vue-chartjs'

export default {
  name: 'TimeseriesGroupsChart',
  components: {Line},
  props: ['data'],
  data() {
    return {
      chartOptions: {
        responsive: true
      }
    }
  },
  computed: {
    chartData() {
      let labels = null
      let datasets = []

      for (const [key, value] of Object.entries(this.data)) {
        if (!labels) {
          labels = value.timestamps
        }

        for (const [key2, value2] of Object.entries(value)) {
          if (key2 === 'timestamps')
            continue

          datasets.push({data: value2, label: `${key} ${key2}`})
        }
      }

      return {
        labels: labels,
        datasets: datasets
      }
    }
  },
}
</script>
